module.exports = __webpack_public_path__ + "static/media/alarampa.546ebfbd.webp";